import React, { Component } from "react";

export default class SafeImg extends Component {
  render() {
    const { theme, ...svgProps } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" {...svgProps}>
    <g id="freepik--background-complete--inject-597">
      <rect
        x={287.62}
        y={68.5}
        width={365.8}
        height={245}
        fill={theme.compImgHighlight}
      />
      <rect
        x={287.62}
        y={68.5}
        width={365.8}
        height={24.47}
        fill={theme.compImgHighlight}
      />
      <path
        d="M303.47,80.74a3,3,0,1,1-3-2.75A2.86,2.86,0,0,1,303.47,80.74Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M313,80.74a3,3,0,1,1-3-2.75A2.86,2.86,0,0,1,313,80.74Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M322.55,80.74a3,3,0,1,1-3-2.75A2.86,2.86,0,0,1,322.55,80.74Z"
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Plant--inject-597">
      <path
        d="M621.53,345.45c-19.12-13.35-23.45-38.14-22.7-60.42.13-3.72-.28-7.64,1.49-10.91s5.9-5.49,9.23-3.92c2.76,1.3,4,4.51,5.51,7.17a21.77,21.77,0,0,0,8.72,8.33c2.37,1.23,5.3,2,7.64.69,3.21-1.77,3.59-6.2,3.56-9.9q-.06-10.35-.13-20.69c0-3.7,0-7.47,1.12-11s3.69-6.77,7.21-7.75,7.87,1,8.62,4.66a33.69,33.69,0,0,1,.1,4.61c.11,1.53.82,3.23,2.28,3.66s3-.62,4.06-1.7c3.82-3.73,6.41-8.55,8.83-13.33s4.77-9.69,8.24-13.76,8.26-7.3,13.55-7.6,10.95,3,12.29,8.17-1.7,10.51-5,14.73a83,83,0,0,1-17.2,16.39c-1.16.82-2.43,1.72-2.87,3.09-.81,2.47,1.53,4.92,4,5.73,2.76.91,5.75.63,8.64,1s6,1.61,7.1,4.34c1.51,3.78-1.65,7.74-4.76,10.34a70.7,70.7,0,0,1-20.94,12.08c-2.72,1-5.58,1.87-7.78,3.78s-3.51,5.24-2.19,7.85,4.73,3.44,7.58,2.91,5.4-2.08,8.12-3.1c5.08-1.92,11.65-1.57,14.91,2.82,2.14,2.89,2.32,6.91,1.24,10.36a27,27,0,0,1-5.61,9.14c-8.14,9.56-18.58,17.26-30.37,21.34s-22.72,5.2-34.44.91"
        fill={theme.imageHighlight}
      />
      <path
        d="M621.24,362a161.77,161.77,0,0,1,6-30.49,331,331,0,0,1,13.16-35.69l3.93-9.18c1.3-3,2.58-6,4-8.84a166.32,166.32,0,0,1,9.2-15.85c3.17-4.9,6.35-9.44,9.36-13.66s5.91-8.08,8.7-11.5A131.89,131.89,0,0,1,690,221.62c1.83-1.64,3.29-2.88,4.29-3.7l1.14-.93.4-.3a2.3,2.3,0,0,1-.36.36l-1.1,1c-1,.85-2.39,2.12-4.19,3.79A139.72,139.72,0,0,0,676,237.07c-2.75,3.43-5.61,7.32-8.61,11.54s-6.15,8.77-9.3,13.67A166.58,166.58,0,0,0,649,278.09c-1.42,2.83-2.69,5.78-4,8.8l-3.93,9.18a339.19,339.19,0,0,0-13.18,35.6A165.86,165.86,0,0,0,621.71,362"
        fill={theme.text}
      />
      <path
        d="M648.58,277.76a8.45,8.45,0,0,1-.36-1.58c-.19-1-.42-2.51-.68-4.35-.53-3.69-1.08-8.8-1.66-14.44s-1.2-10.73-1.78-14.39c-.28-1.83-.53-3.32-.71-4.34a7.74,7.74,0,0,1-.21-1.6,7.11,7.11,0,0,1,.47,1.55c.26,1,.58,2.48.92,4.31.7,3.65,1.4,8.75,2,14.4s1.07,10.6,1.45,14.44c.19,1.74.35,3.21.47,4.38A7,7,0,0,1,648.58,277.76Z"
        fill={theme.text}
      />
      <path
        d="M696.15,268.87a11.68,11.68,0,0,1-1.9.22c-1.22.11-3,.26-5.16.51-4.36.47-10.35,1.33-16.93,2.57s-12.47,2.64-16.71,3.76c-2.12.55-3.83,1-5,1.37a10.49,10.49,0,0,1-1.86.46,9.94,9.94,0,0,1,1.78-.72c1.16-.4,2.85-1,5-1.58,4.21-1.25,10.12-2.71,16.71-4a168.77,168.77,0,0,1,17-2.37c2.19-.19,4-.27,5.2-.29A9.78,9.78,0,0,1,696.15,268.87Z"
        fill={theme.text}
      />
      <path
        d="M627.87,330.61s-.14-.19-.33-.58-.49-1-.81-1.72c-.7-1.5-1.66-3.69-2.81-6.42-2.29-5.44-5.22-13.07-8.35-21.53s-6-16.11-8.16-21.59l-2.59-6.5-.7-1.77a2.69,2.69,0,0,1-.2-.64,2.52,2.52,0,0,1,.32.58c.22.47.49,1,.82,1.72.7,1.5,1.65,3.69,2.8,6.42,2.29,5.45,5.23,13.07,8.35,21.54s6,16.1,8.16,21.59l2.6,6.49.69,1.77A2.51,2.51,0,0,1,627.87,330.61Z"
        fill={theme.text}
      />
      <path
        d="M691.07,310.24a2.69,2.69,0,0,1-.63.26l-1.83.61-6.77,2.2c-5.72,1.85-13.58,4.5-22.26,7.44S643,326.27,637.24,328c-2.88.87-5.21,1.55-6.84,2l-1.87.49a2.56,2.56,0,0,1-.66.13,2.71,2.71,0,0,1,.62-.26l1.84-.61,6.77-2.2c5.71-1.85,13.57-4.5,22.26-7.44s16.58-5.52,22.34-7.26c2.87-.87,5.21-1.55,6.83-2l1.87-.49A2.52,2.52,0,0,1,691.07,310.24Z"
        fill={theme.text}
      />
    </g>
    <g id="freepik--Sparkles--inject-597">
      <path
        d="M202.35,184.36c0,.22-1.59.39-3.55.39s-3.55-.17-3.55-.39,1.59-.39,3.55-.39S202.35,184.15,202.35,184.36Z"
        fill={theme.text}
      />
      <path
        d="M206.11,174.71c.22,0,.4,1.61.4,3.6s-.18,3.6-.4,3.6-.39-1.61-.39-3.6S205.9,174.71,206.11,174.71Z"
        fill={theme.text}
      />
      <path
        d="M210.13,184.13c0-.22,1.58-.39,3.54-.39s3.55.17,3.55.39-1.59.39-3.55.39S210.13,184.35,210.13,184.13Z"
        fill={theme.text}
      />
      <path
        d="M206.36,193.78c-.22,0-.39-1.61-.39-3.6s.17-3.6.39-3.6.39,1.61.39,3.6S206.58,193.78,206.36,193.78Z"
        fill={theme.text}
      />
      <path
        d="M212.09,189.64c-.16.14-.86-.42-1.56-1.26s-1.13-1.62-1-1.76.87.43,1.56,1.26S212.26,189.5,212.09,189.64Z"
        fill={theme.text}
      />
      <path
        d="M211.76,178.7c.16.15-.31.87-1,1.6s-1.43,1.19-1.59,1,.31-.87,1-1.6S211.61,178.55,211.76,178.7Z"
        fill={theme.text}
      />
      <path
        d="M203.63,181.49c-.14.16-.81-.17-1.5-.74s-1.13-1.17-1-1.34.81.16,1.49.74S203.77,181.32,203.63,181.49Z"
        fill={theme.text}
      />
      <path
        d="M203.31,186.31c.16.15-.24.85-.9,1.57s-1.32,1.18-1.48,1,.25-.85.9-1.57S203.15,186.16,203.31,186.31Z"
        fill={theme.text}
      />
      <path
        d="M60.9,290.85a4.57,4.57,0,0,1-2,.23,4.54,4.54,0,0,1-2-.23,4.81,4.81,0,0,1,2-.22A4.84,4.84,0,0,1,60.9,290.85Z"
        fill={theme.text}
      />
      <path
        d="M63,285.38a9.57,9.57,0,0,1,0,4.08,9.16,9.16,0,0,1,0-4.08Z"
        fill={theme.text}
      />
      <path
        d="M65.31,290.72a4.88,4.88,0,0,1,2-.22,4.81,4.81,0,0,1,2,.22,4.54,4.54,0,0,1-2,.23A4.6,4.6,0,0,1,65.31,290.72Z"
        fill={theme.text}
      />
      <path
        d="M63.18,296.2a4.66,4.66,0,0,1-.23-2,4.72,4.72,0,0,1,.23-2.05,5,5,0,0,1,.22,2.05A4.94,4.94,0,0,1,63.18,296.2Z"
        fill={theme.text}
      />
      <path
        d="M66.43,293.85c-.09.08-.49-.24-.89-.71s-.64-.92-.54-1,.49.24.89.71S66.52,293.77,66.43,293.85Z"
        fill={theme.text}
      />
      <path
        d="M66.24,287.64c.09.08-.17.49-.58.91s-.82.67-.9.59.17-.49.58-.91S66.15,287.55,66.24,287.64Z"
        fill={theme.text}
      />
      <path
        d="M61.63,289.22c-.08.1-.46-.09-.85-.42s-.65-.66-.57-.76.46.1.85.42S61.7,289.13,61.63,289.22Z"
        fill={theme.text}
      />
      <path
        d="M61.44,292c.1.08-.13.48-.51.89s-.74.67-.83.59.13-.48.51-.89S61.35,291.88,61.44,292Z"
        fill={theme.text}
      />
      <path
        d="M211.74,273l.23.56a3.92,3.92,0,0,0,2.16,2.13l.6.25-.58.23a4,4,0,0,0-2.17,2.17l-.16.41-.25-.51a3.89,3.89,0,0,0-2.19-2l-.53-.19.69-.34a4,4,0,0,0,1.92-2Z"
        fill={theme.text}
      />
      <path
        d="M104.14,201.69l.23.56a3.94,3.94,0,0,0,2.15,2.13l.6.24-.57.24a3.92,3.92,0,0,0-2.17,2.17l-.17.41-.24-.51a3.88,3.88,0,0,0-2.2-2l-.52-.19.68-.34a3.94,3.94,0,0,0,1.92-2Z"
        fill={theme.text}
      />
    </g>
    <g id="freepik--Device--inject-597">
      <rect
        x={222.79}
        y={115.91}
        width={402.04}
        height={265.86}
        rx={14.57}
        fill={theme.text}
      />
      <path
        d="M206,362.11H641.55a0,0,0,0,1,0,0v5.47a17.8,17.8,0,0,1-17.8,17.8h-400a17.8,17.8,0,0,1-17.8-17.8v-5.47A0,0,0,0,1,206,362.11Z"
        fill={theme.text}
      />
      <rect
        x={233.58}
        y={126.48}
        width={379.33}
        height={224.52}
        fill={theme.text}
      />
      <polygon
        points="384.17 362.11 389.58 370.71 465.63 370.71 470.65 362.11 384.17 362.11"
        fill={theme.text}
      />
      <rect
        x={241.39}
        y={134.08}
        width={364.48}
        height={216.2}
        rx={3.27}
        fill={theme.compImgHighlight}
      />
      <rect
        x={241.39}
        y={149.92}
        width={364.48}
        height={200.36}
        fill={theme.compImgHighlight}
      />
      <path
        d="M271.29,142.43a2.92,2.92,0,1,1-2.92-2.92A2.92,2.92,0,0,1,271.29,142.43Z"
        fill={theme.text}
      />
      <path
        d="M253.64,142.43a2.91,2.91,0,1,1-2.91-2.92A2.91,2.91,0,0,1,253.64,142.43Z"
        fill={theme.text}
      />
      <path
        d="M262.11,142.43a2.91,2.91,0,1,1-2.91-2.92A2.91,2.91,0,0,1,262.11,142.43Z"
        fill={theme.text}
      />
      <path
        d="M621.37,362.11c0,.15-89.23.26-199.28.26s-199.3-.11-199.3-.26,89.21-.26,199.3-.26S621.37,362,621.37,362.11Z"
        fill={theme.text}
      />
      <rect
        x={266.65}
        y={250.85}
        width={83.17}
        height={5.56}
        fill={theme.compImgHighlight}
      />
      <rect
        x={374.08}
        y={173.6}
        width={83.17}
        height={5.56}
        fill={theme.compImgHighlight}
      />
      <path
        d="M581,194.32c0,.14-46.32.26-103.43.26s-103.45-.12-103.45-.26,46.31-.26,103.45-.26S581,194.18,581,194.32Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M581,206.47c0,.14-46.32.26-103.43.26s-103.45-.12-103.45-.26,46.31-.26,103.45-.26S581,206.33,581,206.47Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M581,218.62c0,.14-46.32.26-103.43.26s-103.45-.12-103.45-.26,46.31-.26,103.45-.26S581,218.47,581,218.62Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M581,230.77c0,.14-46.32.26-103.43.26s-103.45-.12-103.45-.26,46.31-.26,103.45-.26S581,230.62,581,230.77Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M581,242.92c0,.14-46.32.26-103.43.26s-103.45-.12-103.45-.26,46.31-.26,103.45-.26S581,242.77,581,242.92Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M454.84,255.07c0,.14-18.08.26-40.38.26s-40.38-.12-40.38-.26,18.08-.26,40.38-.26S454.84,254.92,454.84,255.07Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M579.45,278.65c0,.14-30.45.26-68,.26s-68-.12-68-.26,30.44-.26,68-.26S579.45,278.5,579.45,278.65Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M579.45,291.54c0,.15-30.45.26-68,.26s-68-.11-68-.26,30.44-.26,68-.26S579.45,291.4,579.45,291.54Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M579.45,304.44c0,.14-30.45.26-68,.26s-68-.12-68-.26,30.44-.26,68-.26S579.45,304.3,579.45,304.44Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M579.45,317.34c0,.14-30.45.26-68,.26s-68-.12-68-.26,30.44-.26,68-.26S579.45,317.19,579.45,317.34Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M350,277.41c0,.15-18.15.26-40.53.26s-40.53-.11-40.53-.26,18.14-.26,40.53-.26S350,277.27,350,277.41Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M350,287.54c0,.14-18.15.26-40.53.26s-40.53-.12-40.53-.26,18.14-.26,40.53-.26S350,287.4,350,287.54Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M350,297.67c0,.14-18.15.26-40.53.26s-40.53-.12-40.53-.26,18.14-.26,40.53-.26S350,297.52,350,297.67Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M350,307.8c0,.14-18.15.26-40.53.26S269,307.94,269,307.8s18.14-.26,40.53-.26S350,307.65,350,307.8Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M350,317.92c0,.15-18.15.27-40.53.27s-40.53-.12-40.53-.27,18.14-.26,40.53-.26S350,317.78,350,317.92Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={374.03}
        y={272.49}
        width={59.01}
        height={57.09}
        fill={theme.compImgHighlight}
      />
      <polygon
        points="378.61 324.7 394.93 295.32 408.28 314.1 416.4 304.13 428.47 324.7 378.61 324.7"
        fill={theme.compImgHighlight}
      />
      <path
        d="M414,289.61a4.25,4.25,0,1,1-4.25-4.25A4.24,4.24,0,0,1,414,289.61Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M428.47,324.86a1.35,1.35,0,0,1,0-.24c0-.17,0-.39,0-.66,0-.61,0-1.47,0-2.57,0-2.27,0-5.54-.06-9.7,0-8.34-.07-20.21-.12-34.47l.24.24-49.86,0c-.07.06.53-.53.28-.27h0v6.45q0,3.21,0,6.36v12.3c0,8,0,15.55,0,22.51l-.24-.25,36.05.13,10.17.06,2.69,0h.7l.25,0h-.22l-.67,0-2.65,0-10.12.07-36.2.12h-.25v-.24c0-7,0-14.52,0-22.51,0-4,0-8.11,0-12.3V277.24h0c-.26.24.34-.35.28-.29l49.86,0h.24v.24c0,14.32-.1,26.25-.12,34.63,0,4.13,0,7.39-.07,9.64q0,1.62,0,2.52c0,.27,0,.48,0,.64A1.66,1.66,0,0,1,428.47,324.86Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={268.22}
        y={164.1}
        width={80.04}
        height={77.43}
        fill={theme.compImgHighlight}
      />
      <polygon
        points="274.43 234.91 296.57 195.06 314.68 220.53 325.68 207 342.05 234.91 274.43 234.91"
        fill={theme.compImgHighlight}
      />
      <path
        d="M322.39,187.31a5.76,5.76,0,1,1-5.76-5.76A5.76,5.76,0,0,1,322.39,187.31Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M342.05,235.12s0-.11,0-.31,0-.53,0-.91c0-.82,0-2,0-3.48,0-3.07-.05-7.51-.09-13.15,0-11.31-.1-27.42-.17-46.76l.33.33-67.62,0,.38-.37v8.77c0,2.9,0,5.77,0,8.62,0,5.69,0,11.26,0,16.68,0,10.85,0,21.1,0,30.53l-.33-.33,48.89.17,13.79.09,3.66,0h1l.33,0a.83.83,0,0,1-.29,0l-.92,0-3.59,0-13.72.09-49.1.17h-.34v-.34c0-9.43,0-19.68,0-30.53,0-5.42,0-11,0-16.68V170.52l.39-.39,67.62.05h.33v.32c-.07,19.43-.13,35.6-.17,47,0,5.6-.06,10-.08,13.07,0,1.47,0,2.62,0,3.42,0,.37,0,.65,0,.87A1.32,1.32,0,0,1,342.05,235.12Z"
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Padlock--inject-597">
      <path
        d="M463.82,221.81l-8-.11.3-21.78a29.13,29.13,0,0,0-58.26.06l-.3,21.83-8-.11.3-21.78a37.13,37.13,0,0,1,74.26.06Z"
        fill={theme.text}
      />
      <rect
        x={371.99}
        y={211.2}
        width={110.86}
        height={108.31}
        rx={18.29}
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M438.46,259.64A11.05,11.05,0,1,0,421.6,269l-2.83,13.09h18.12s-2-8.23-3.32-13.3A11.06,11.06,0,0,0,438.46,259.64Z" />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M379.08,286.67c-.72,0-1-12.65-.71-28.22s1.17-28.19,1.89-28.17,1,12.65.71,28.22S379.8,286.68,379.08,286.67Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M379.16,299.2c-.72,0-1.31-1.22-1.33-2.75s.54-2.77,1.26-2.78,1.32,1.22,1.34,2.75S379.88,299.19,379.16,299.2Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M413.94,283.89c-.57-.19.78-5.95,3.13-13.61l.3,1.26c-1.07-1.06-2.18-2.17-3.34-3.4a12.16,12.16,0,0,1-3-7.35,11.31,11.31,0,0,1,1.48-6.25,9.62,9.62,0,0,1,2.81-3.17c.82-.57,1.37-.72,1.46-.58.26.31-1.43,1.65-2.62,4.56a10.66,10.66,0,0,0,1.79,11l3.22,3.4.53.57-.24.7C416.83,278.63,414.51,284.07,413.94,283.89Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M459.7,218.72c0,.36-4.43.66-11.58.84s-17,.25-28,.17c-5.46,0-10.66-.12-15.39-.22s-9-.39-12.41,0a16,16,0,0,0-7.59,2.56c-1.59,1.09-2.24,2-2.42,1.88s.25-1.21,1.78-2.66a15.19,15.19,0,0,1,8-3.6,39.71,39.71,0,0,1,6-.47l6.72-.07c4.73,0,9.93,0,15.39,0,10.92.08,20.8.31,27.95.6S459.7,218.36,459.7,218.72Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </g>
    <g id="freepik--Character--inject-597">
      <path
        d="M85.59,450.16l-.71,2.66S75.25,468.49,76.39,470A6.13,6.13,0,0,0,83.07,472c3.35-.84,17.49-14.27,17.49-14.27l.81-2.15Z"
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M77.35,466.4s4.17-1.84,6.58,3.55c0,0,1.8-.68,6.8-4.86s9.83-8.28,9.83-8.28.52-.42.37,0-.37,1.13-.37,1.13l-9.65,8.51s-5.78,5-7.23,5.36-2.92.88-4.76.06a5.13,5.13,0,0,1-2.75-2.39C76.17,469.24,77.35,466.4,77.35,466.4Z" />
      </g>
      <path
        d="M84.49,471.71c-.06,0-.16-.53-.51-1.33a7.37,7.37,0,0,0-5-4.22c-.85-.2-1.4-.21-1.4-.26A3.31,3.31,0,0,1,79,466a6.88,6.88,0,0,1,3.17,1.49,7,7,0,0,1,2,2.85A3.7,3.7,0,0,1,84.49,471.71Z"
        fill={theme.text}
      />
      <path
        d="M101.37,456.12a1.43,1.43,0,0,1-.22.23l-.68.6L98,459.13l-8.37,7.08a35.68,35.68,0,0,1-4.82,3.66A7.75,7.75,0,0,1,80,471a4.8,4.8,0,0,1-3-1.5,3,3,0,0,1-.65-1,6.54,6.54,0,0,0,.74,1A4.86,4.86,0,0,0,80,470.79a7.68,7.68,0,0,0,4.62-1.17A36.72,36.72,0,0,0,89.39,466c3.25-2.7,6.18-5.15,8.43-7l2.57-2.1.72-.56A1.22,1.22,0,0,1,101.37,456.12Z"
        fill={theme.text}
      />
      <path
        d="M86.11,462.71a10.75,10.75,0,0,1-1.78-1.1,11.66,11.66,0,0,1-1.73-1.19,5.32,5.32,0,0,1,1.9.92A5.37,5.37,0,0,1,86.11,462.71Z"
        fill={theme.text}
      />
      <path
        d="M88.18,460.46a13.87,13.87,0,0,1-2.19-.91,12.24,12.24,0,0,1-2.14-1,6.82,6.82,0,0,1,2.27.72A7.12,7.12,0,0,1,88.18,460.46Z"
        fill={theme.text}
      />
      <path
        d="M90.1,458.53c-.07.07-.94-.7-2.2-1.31s-2.4-.86-2.38-1a5,5,0,0,1,2.51.67A5.22,5.22,0,0,1,90.1,458.53Z"
        fill={theme.text}
      />
      <path
        d="M91.21,456.23c0,.07-.86-.52-2-1s-2.1-.71-2.08-.8a4.52,4.52,0,0,1,2.21.52A4.31,4.31,0,0,1,91.21,456.23Z"
        fill={theme.text}
      />
      <path
        d="M90.73,454.05a3.9,3.9,0,0,1-1.2-.8,8.87,8.87,0,0,1-1.08-1.11,7.25,7.25,0,0,1-.55-.75,1.67,1.67,0,0,1-.25-.46.6.6,0,0,1,.1-.61,1,1,0,0,1,1.09-.13,2.33,2.33,0,0,1,.8.55,3,3,0,0,1,.73,1.41,4,4,0,0,1,.1,1.05c0,.25,0,.39-.06.39s0-.56-.25-1.38a3,3,0,0,0-.73-1.27,2.15,2.15,0,0,0-.7-.47.73.73,0,0,0-.74,0c-.16.16,0,.45.16.7s.35.51.52.74a10.88,10.88,0,0,0,1,1.13C90.31,453.7,90.75,454,90.73,454.05Z"
        fill={theme.text}
      />
      <path
        d="M90.52,453.78s0-.15.1-.39a3.67,3.67,0,0,1,.58-.91,4.12,4.12,0,0,1,2.16-1.35,1.32,1.32,0,0,1,.56,0,.62.62,0,0,1,.46.45,1.26,1.26,0,0,1-.42,1,3.56,3.56,0,0,1-.72.64,3.8,3.8,0,0,1-1.5.59,3.31,3.31,0,0,1-1.09,0c-.25,0-.38-.1-.38-.12a7.67,7.67,0,0,0,1.42-.1,3.89,3.89,0,0,0,1.38-.62,3.09,3.09,0,0,0,.66-.6,1,1,0,0,0,.34-.75c0-.23-.36-.28-.65-.22a3.72,3.72,0,0,0-.83.3,4.34,4.34,0,0,0-1.23.89A9.37,9.37,0,0,0,90.52,453.78Z"
        fill={theme.text}
      />
      <path
        d="M98.63,454.87a2.32,2.32,0,0,0-1.36.07,5.06,5.06,0,0,0-2.43,2.21,5.43,5.43,0,0,0-.64,3.24c.1.86.33,1.36.28,1.38a3,3,0,0,1-.5-1.35,5.23,5.23,0,0,1,.59-3.42,4.88,4.88,0,0,1,2.63-2.27A1.46,1.46,0,0,1,98.63,454.87Z"
        fill={theme.text}
      />
      <path
        d="M92.92,461.18a7.92,7.92,0,0,1-1.63,1.59,8.28,8.28,0,0,1-1.83,1.36,7.92,7.92,0,0,1,1.63-1.59A8.55,8.55,0,0,1,92.92,461.18Z"
        fill={theme.text}
      />
      <path
        d="M94.83,460.16c.09,0,.2.2.26.46s0,.49,0,.52-.2-.17-.26-.46S94.75,460.17,94.83,460.16Z"
        fill={theme.text}
      />
      <path
        d="M95.08,458.19c.08,0,.1.27,0,.52s-.19.46-.27.45-.1-.24,0-.52S95,458.16,95.08,458.19Z"
        fill={theme.text}
      />
      <path
        d="M96.13,456.51c.07.07,0,.26-.2.48s-.35.34-.42.3,0-.27.18-.5S96.08,456.45,96.13,456.51Z"
        fill={theme.text}
      />
      <path
        d="M97.83,455.47c0,.08-.15.24-.39.36s-.47.14-.52.07.13-.23.39-.36S97.8,455.39,97.83,455.47Z"
        fill={theme.text}
      />
      <path
        d="M99.8,455.24c0,.09-.24.16-.5.16s-.49-.07-.5-.15.21-.16.5-.16S99.81,455.15,99.8,455.24Z"
        fill={theme.text}
      />
      <path
        d="M218.43,202c-.62.75-1.5,8.69-1.5,8.69s-14.65,25-16.69,25.35-10.93-17.35-10.93-17.35l-9.13,8.41s4.76,22.34,19.64,26.17c7,1.81,19.28-20.47,27.46-39,.14-.3,4.37-10.38,4.37-10.38Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M231.49,204.76s0,.11-.05.25c-.38,1.2-2.65,6.14-3.35,6.09s-2.32-1.2-2.15-1.91,3.05-6.14,3.05-6.14.5-.83,2.08-.39C232.05,202.94,231.49,204.76,231.49,204.76Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M229.29,201.65s0,.11,0,.26c-.38,1.19-2.65,6.14-3.35,6.08s-2.32-1.2-2.14-1.91,3-6.13,3-6.13.51-.83,2.08-.39C229.85,199.83,229.29,201.65,229.29,201.65Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M226.76,199.47s0,.11,0,.25c-.38,1.2-2.65,6.15-3.35,6.09s-2.31-1.2-2.14-1.91,3-6.13,3-6.13.51-.83,2.09-.4C227.32,197.65,226.76,199.47,226.76,199.47Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M224.23,197.35a.74.74,0,0,1,0,.25c-.39,1.2-2.65,6.15-3.35,6.09s-2.32-1.2-2.15-1.91,3-6.14,3-6.14.51-.83,2.09-.39C224.78,195.53,224.23,197.35,224.23,197.35Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M226.56,207.72a9.76,9.76,0,0,0,1.3-2.32,10.05,10.05,0,0,0,1-2.43,11.29,11.29,0,0,0-1.3,2.32A10.77,10.77,0,0,0,226.56,207.72Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M223.62,206.45a20.75,20.75,0,0,0,1.8-3.33,21.09,21.09,0,0,0,1.49-3.47,20.75,20.75,0,0,0-1.8,3.33A21.09,21.09,0,0,0,223.62,206.45Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <g
        style={{
          opacity: 0.78,
        }}
      >
        <path
          d="M220.75,204.89a21.21,21.21,0,0,0,1.79-3.33,20.1,20.1,0,0,0,1.49-3.47,21.89,21.89,0,0,0-1.8,3.32A20.77,20.77,0,0,0,220.75,204.89Z"
          style={{
            fill: "#7c4435",
          }}
        />
      </g>
      <path
        d="M218.45,211.83l-1-4.38a7.63,7.63,0,0,1,.89-5.62l.78-1.29,9.57,4.84s-2.39,3.11-4.8,1.28l1.76,3.78Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M224.8,210.78c-.06,0,0-.51-.09-1.36a4.83,4.83,0,0,0-1.72-3l-.92-.74,1.12.36,2.49.81-.06,0a2.9,2.9,0,0,0,2.87-1.19,1,1,0,0,0,.12-.22l.13.32c-2.76-1.25-5.24-2.42-7-3.37A15.59,15.59,0,0,1,219,200.7a27,27,0,0,1,2.9,1.35c1.77.86,4.26,2,7,3.22l.22.1-.08.23a2.25,2.25,0,0,1-.16.31,2.9,2.9,0,0,1-1.55,1.24,4.09,4.09,0,0,1-1.82.17h0l-2.46-.86.2-.37a4.89,4.89,0,0,1,1.7,3.31A2.66,2.66,0,0,1,224.8,210.78Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M227.32,206.54c.1,0-.08.54,0,1.25a.92.92,0,0,0,.72.76,1.37,1.37,0,0,0,1.17-.73c.64-1,1.28-1.93,1.67-2.61s.6-1.12.67-1.1,0,.52-.34,1.27a23.16,23.16,0,0,1-1.57,2.73A1.8,1.8,0,0,1,228,209a1.31,1.31,0,0,1-1-1.18,2.13,2.13,0,0,1,.15-1C227.22,206.64,227.29,206.53,227.32,206.54Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M185.78,270.47s-8.15-20.07-8.11-20.45l2.11-7.47.85-4.32,2.76,3.21,13.47-14.08c.25.34-6.1-8.88-12.53-17.9-4.48-6.28-9.33-7.66-12.16-7.86a19.42,19.42,0,0,0-3.61-.74l-23.18-.2a22,22,0,0,0-13.84,5.07c-1.07.88-9.95,12.69-16,24.37l18.64,13.45,3.07-5.4v.11c.26,1.83,1.37,7.17,1.73,9,1.13,5.63,1.49,12.41-1.26,17.06a143.91,143.91,0,0,0-5.34,15.95h57.2S187.74,275.3,185.78,270.47Z"
        fill={theme.text}
      />
      <path
        d="M139.76,262.08l-2-1.58v-.18l-.08.1L124.75,250l5.55-9.15-13.4-9.79c.06.65-12.43,19.17-10.74,22.81,2.39,5.14,18.62,15.42,25.26,19.47a41.41,41.41,0,0,0-5.36,1.06c-1.69.55,3.82,2,5.16,2.29.52.1,1.59-.73,2.73-1.83l.31.18.36-.84a39.63,39.63,0,0,0,3.4-4c.28-.43.27-2.38.16-4.44Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M211.45,455.6l-.08-1.89-19.17.55.17,6.24,1.18,0c5.28.13,26.84.32,30.33-.77C227.77,458.56,211.45,455.6,211.45,455.6Z"
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M199.28,460.18a6.07,6.07,0,0,0-2.55-3.72,6.81,6.81,0,0,0-4.5-1.17l.15,5Z" />
      </g>
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M219.43,457.31s5.73,1.37,5,2.26S202,461,192.37,460.5l0-.39,25.42-.47S218.32,457.38,219.43,457.31Z" />
      </g>
      <path
        d="M192.09,460.1l.32,0,1,0,3.47,0c2.94,0,7,0,11.46-.11s8.53-.3,11.45-.47l3.47-.23.94-.07.33,0h-.33l-1,0-3.47.16c-2.92.13-7,.29-11.44.41s-8.53.15-11.46.17l-3.47,0-.94,0Z"
        fill={theme.text}
      />
      <path
        d="M217.82,459.92a6.67,6.67,0,0,1,.6-1.56,7.66,7.66,0,0,1,1.14-1.27,2.6,2.6,0,0,0-1.34,1.16A2.2,2.2,0,0,0,217.82,459.92Z"
        fill={theme.text}
      />
      <path
        d="M212.1,457.41c.06,0,.32-.28.58-.7s.44-.78.39-.81-.32.29-.58.7S212.05,457.38,212.1,457.41Z"
        fill={theme.text}
      />
      <path
        d="M210.53,456.69c.05,0,.34-.15.66-.44s.55-.54.5-.59-.33.15-.66.44S210.49,456.65,210.53,456.69Z"
        fill={theme.text}
      />
      <path
        d="M209.51,455a2.36,2.36,0,0,0,1,.09,2.42,2.42,0,0,0,1-.12,2.39,2.39,0,0,0-1-.09A2.2,2.2,0,0,0,209.51,455Z"
        fill={theme.text}
      />
      <path
        d="M209.13,453.87a3,3,0,0,0,2.27.1,5.42,5.42,0,0,0-1.13-.05A6.84,6.84,0,0,0,209.13,453.87Z"
        fill={theme.text}
      />
      <path
        d="M212.7,455.84a3.46,3.46,0,0,0,1.23,0,7,7,0,0,0,1.3-.3,3.45,3.45,0,0,0,.74-.31.57.57,0,0,0,.29-.36.45.45,0,0,0-.2-.45,2.34,2.34,0,0,0-2.76.69,1.75,1.75,0,0,0-.38.77c0,.19,0,.31,0,.31a3,3,0,0,1,.53-1,2.21,2.21,0,0,1,1-.66,2.07,2.07,0,0,1,1.47.05c.2.13.13.35-.08.47a3.25,3.25,0,0,1-.69.29,7.66,7.66,0,0,1-1.25.34C213.17,455.79,212.7,455.81,212.7,455.84Z"
        fill={theme.text}
      />
      <path
        d="M213,455.89a1,1,0,0,0,.12-.79,1.86,1.86,0,0,0-.36-.83,1.22,1.22,0,0,0-1-.55.45.45,0,0,0-.36.53,1.32,1.32,0,0,0,.22.51,3.67,3.67,0,0,0,.6.67,1.68,1.68,0,0,0,.72.44s-.25-.19-.6-.55a4.48,4.48,0,0,1-.54-.67c-.17-.23-.3-.66,0-.72s.63.24.82.46a1.87,1.87,0,0,1,.37.73A3.44,3.44,0,0,1,213,455.89Z"
        fill={theme.text}
      />
      <path
        d="M192.33,455.24s.54-.06,1.41,0a6.37,6.37,0,0,1,3.11,1.1,5.7,5.7,0,0,1,2,2.47c.31.75.36,1.26.4,1.26s0-.13,0-.36a4.08,4.08,0,0,0-.24-1,5.49,5.49,0,0,0-2-2.6,6.1,6.1,0,0,0-3.24-1.07,5.17,5.17,0,0,0-1.05,0A1.23,1.23,0,0,0,192.33,455.24Z"
        fill={theme.text}
      />
      <path
        d="M201.63,458.39a17,17,0,0,0,5.58-.1c0-.06-1.25,0-2.79.06S201.64,458.32,201.63,458.39Z"
        fill={theme.text}
      />
      <path
        d="M197.89,458.48s.11.24.25.5.21.5.27.5.09-.29-.07-.59S197.93,458.43,197.89,458.48Z"
        fill={theme.text}
      />
      <path
        d="M196.43,456.88c0,.05.09.23.29.41s.4.29.45.25-.09-.22-.29-.41S196.48,456.84,196.43,456.88Z"
        fill={theme.text}
      />
      <path
        d="M194.39,456.19c0,.06.27.05.55.14s.49.22.54.17-.12-.28-.47-.38S194.37,456.14,194.39,456.19Z"
        fill={theme.text}
      />
      <path
        d="M193,455.88c0,.05.09.14.25.2s.3.05.33,0-.1-.14-.26-.2S193,455.82,193,455.88Z"
        fill={theme.text}
      />
      <path
        d="M155.28,153.56a7,7,0,0,0-8.15-.63c-1.23.79-2.2,2-3.53,2.58-2.21,1-4.81.22-7.2.6a7.61,7.61,0,0,0-6.17,7.64c.1,1.92.92,4,0,5.67-.82,1.48-2.67,2-4,3.06a5.7,5.7,0,0,0-.79,7.74,28.28,28.28,0,0,1,2.25,2.4c.94,1.47.81,3.35,1.05,5.07s1.23,3.68,3,3.79c1.41.09,2.66-1.08,4.06-1,2,.16,2.77,2.52,3.91,4.13a7,7,0,0,0,6.51,2.83c1.79-.24,3.56-1.18,5.3-.74,2.2.56,3.52,3.13,5.76,3.45,1.67.24,3.22-.87,4.46-2s2.5-2.45,4.16-2.75c2-.36,3.92.85,5.93,1.13a6.73,6.73,0,0,0,6.61-3.32c1.1-2,1.1-4.46,2.13-6.5a37.41,37.41,0,0,1,2.67-3.74,5,5,0,0,0,1-4.32c-.36-1-1.24-1.83-1.67-2.84-.64-1.52-.17-3.24,0-4.88s-.17-3.63-1.67-4.31a14.08,14.08,0,0,1-1.93-.64c-1.17-.72-1.11-2.39-1.21-3.76a6.29,6.29,0,0,0-2.84-5.05c-1.75-1-4.34-.5-5.22,1.3"
        fill={theme.text}
      />
      <path
        d="M144.09,172a13,13,0,0,1,7-18.48,20.59,20.59,0,0,1,7.85-.91,16.39,16.39,0,0,1,6.61,1.35,7.15,7.15,0,0,1,4.09,5.09"
        fill={theme.imageHighlight}
      />
      <path
        d="M156.57,212.48h0a9.18,9.18,0,0,0,9.88-8.81c.19-5,.36-10.06.36-10.06s7.58-.7,8.13-8.2.3-24.82.3-24.82h0a26.14,26.14,0,0,0-26.41,1.7l-1.17.79.43,40.34A9.19,9.19,0,0,0,156.57,212.48Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M171.67,173.79a1.09,1.09,0,1,1,1.54,0A1.09,1.09,0,0,1,171.67,173.79Z"
        fill={theme.text}
      />
      <path
        d="M174.59,172.52c-.12.13-.83-.48-1.86-.55s-1.81.42-1.92.28.08-.29.42-.52a2.54,2.54,0,0,1,3,.22C174.56,172.23,174.65,172.47,174.59,172.52Z"
        fill={theme.text}
      />
      <path
        d="M161.87,172.38a1.09,1.09,0,1,1-1.25,1.78,1.09,1.09,0,1,1,1.25-1.78Z"
        fill={theme.text}
      />
      <path
        d="M163.32,172.76a2.14,2.14,0,0,0-1.86-.55c-1-.09-1.82.42-1.93.28s.08-.29.43-.52a2.52,2.52,0,0,1,1.54-.39,2.57,2.57,0,0,1,1.48.61C163.28,172.47,163.38,172.71,163.32,172.76Z"
        fill={theme.text}
      />
      <path
        d="M167,180.79a5.13,5.13,0,0,1,1.69-.25c.28,0,.49-.06.52-.21a1.43,1.43,0,0,0-.15-.78c-.22-.7-.45-1.41-.69-2.15a29.71,29.71,0,0,1-1.43-5.63c.16-.05,1,2.39,2,5.45l.64,2.17a1.7,1.7,0,0,1,.08,1.13.69.69,0,0,1-.49.4,1.62,1.62,0,0,1-.47,0A5,5,0,0,1,167,180.79Z"
        fill={theme.text}
      />
      <path
        d="M166.83,193.51a17.51,17.51,0,0,1-9.61-3.38s2,5.54,9.51,5.32Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M154.51,158a7.07,7.07,0,0,0,6,6.18c1.84.22,3.84-.29,5.5.54a9.69,9.69,0,0,1,2.8,2.83,4.46,4.46,0,0,0,3.32,2,8.71,8.71,0,0,0,1.88-.44,2.19,2.19,0,0,1,1.86.2,14.32,14.32,0,0,0,1.11-7,6.43,6.43,0,0,0-4.14-5.35c-1.49-.45-3.1-.16-4.63-.43a15.56,15.56,0,0,1-3.6-1.32,11.25,11.25,0,0,0-6.18-1.32c-2.12.32-4.16,2.06-4.1,4.2"
        fill={theme.text}
      />
      <path
        d="M148.19,178.52c2.72,2.19,6-3.47,7.45-7a35,35,0,0,0,2.11-11.35,5.57,5.57,0,0,0-.66-3.65c-.78-1.06-1.13.24-2-.75-1.67-1.94-4.75-.89-6.27-.23-2.53,1.09-4.11,3.92-4.61,6.79a28.27,28.27,0,0,0,.31,8.7c.19,1.32.38,2.64.56,4a6.38,6.38,0,0,0,.79,2.67,1.9,1.9,0,0,0,2.29.88"
        fill={theme.text}
      />
      <path
        d="M148.09,172.35a1.14,1.14,0,0,0-1.09-1.13c-1.4,0-3.69.52-3.9,4.38-.3,5.52,5,4.14,5,4S148.1,174.5,148.09,172.35Z"
        style={{
          fill: "#a56959",
        }}
      />
      <path
        d="M146.91,177.42s-.1.06-.27.12a1,1,0,0,1-.72,0,2.39,2.39,0,0,1-1-2.2,3.14,3.14,0,0,1,.34-1.36,1.13,1.13,0,0,1,.77-.7.49.49,0,0,1,.55.3c.06.16,0,.26.05.28s.13-.09.09-.32a.58.58,0,0,0-.19-.36A.77.77,0,0,0,146,173a1.36,1.36,0,0,0-1.05.8,3.4,3.4,0,0,0-.42,1.52,2.51,2.51,0,0,0,1.27,2.46,1,1,0,0,0,.89-.09C146.89,177.55,146.93,177.43,146.91,177.42Z"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M164.35,182.12a1.47,1.47,0,0,0,2.49,1.56,1.47,1.47,0,0,0-2.37-1.74"
        style={{
          fill: "#7c4435",
        }}
      />
      <path
        d="M167.79,183.19a2.87,2.87,0,0,1-2.34-.07c-1.27-.45-2-1.34-1.85-1.43s.88.54,2,.93S167.78,183,167.79,183.19Z"
        fill={theme.text}
      />
      <path
        d="M153.72,153.68c-2.05-.28-3.5-2.28-3.85-4.31a14.59,14.59,0,0,1,.72-6.09,8.73,8.73,0,0,1,2.94,10.83"
        fill={theme.imageHighlight}
      />
      <path
        d="M153.7,153.37a3.55,3.55,0,0,1,1.7-4,7.33,7.33,0,0,1,4.5-.8.84.84,0,0,1,.39.11.66.66,0,0,1,.23.47,3.83,3.83,0,0,1-2.15,3.72,11.16,11.16,0,0,1-4.43,1,1.38,1.38,0,0,1-.7-.06.45.45,0,0,1-.25-.59"
        fill={theme.imageHighlight}
      />
      <path
        d="M181,163.28s0-.11-.13-.26a1,1,0,0,0-.68-.38.83.83,0,0,0-1,.54,1.19,1.19,0,0,0,.62,1.33,1.45,1.45,0,0,0,1.7-.55,2.32,2.32,0,0,0,.15-2.2,3.89,3.89,0,0,0-4.48-2.21l-.3.09-1.39.44,1.14-.89a2.26,2.26,0,0,0,.66-2.39,2.82,2.82,0,0,0-1.71-1.73,4.8,4.8,0,0,0-4.22.62c-.54.33-1,.72-1.47,1a2.62,2.62,0,0,1-1.32.4c-.8,0-1.1-.42-1.07-.42a1.82,1.82,0,0,0,1.06.22,2.46,2.46,0,0,0,1.18-.45c.42-.27.86-.68,1.43-1.05a6.34,6.34,0,0,1,2-.89,4.27,4.27,0,0,1,2.56.14,3.24,3.24,0,0,1,2,2,2.75,2.75,0,0,1-.82,3l-.25-.45.35-.11a4.36,4.36,0,0,1,5.06,2.54,2.74,2.74,0,0,1-.26,2.64,1.82,1.82,0,0,1-2.21.6,1.5,1.5,0,0,1-.73-1.75,1,1,0,0,1,.59-.59,1.24,1.24,0,0,1,.68-.05,1,1,0,0,1,.73.53C181.07,163.17,181,163.28,181,163.28Z"
        fill={theme.text}
      />
      <path
        d="M126.1,172.19a1.11,1.11,0,0,1,.55,0,2.25,2.25,0,0,1,1.58,2,1.8,1.8,0,0,1-.46,1.3,2.39,2.39,0,0,1-1.41.74,2.11,2.11,0,0,1-1.72-.48A3.65,3.65,0,0,1,124,172a5.38,5.38,0,0,1,3.1-3.28c.77-.3,1.58-.42,2.34-.65a2.87,2.87,0,0,0,1.81-1.35,4,4,0,0,0,.28-2.39,13.78,13.78,0,0,0-.7-2.54,8.88,8.88,0,0,1-.54-2.71,3.88,3.88,0,0,1,1-2.55,4.86,4.86,0,0,1,2.22-1.4,6.23,6.23,0,0,1,2.49-.18c1.64.17,3,1,4.3,1.19a2.86,2.86,0,0,0,1.84-.25,5.25,5.25,0,0,0,1.38-1.14,7.9,7.9,0,0,1,2.44-2.13,4.63,4.63,0,0,1,2.42-.4,4.17,4.17,0,0,1,1.49.43,3.87,3.87,0,0,1,.35.2l.1.09a5.94,5.94,0,0,0-1.95-.52,4.47,4.47,0,0,0-2.28.46,7.75,7.75,0,0,0-2.3,2.12,5.83,5.83,0,0,1-1.46,1.25,3.32,3.32,0,0,1-2.09.32c-1.46-.22-2.77-1-4.29-1.14a4.79,4.79,0,0,0-4.27,1.44,3.35,3.35,0,0,0-.83,2.22,8,8,0,0,0,.51,2.54,13.82,13.82,0,0,1,.72,2.63,4.49,4.49,0,0,1-.34,2.7,3.32,3.32,0,0,1-2.11,1.58c-.82.25-1.62.36-2.32.62a5,5,0,0,0-2.86,3,3.31,3.31,0,0,0,.43,3.44,2,2,0,0,0,2.67-.19,1.72,1.72,0,0,0,.15-2.09,2.07,2.07,0,0,0-1.09-1C126.29,172.21,126.1,172.21,126.1,172.19Z"
        fill={theme.text}
      />
      <path
        d="M157.92,177.49a.24.24,0,0,1-.33-.11.25.25,0,0,1,.16-.3.26.26,0,0,1,.33.11A.25.25,0,0,1,157.92,177.49Z"
        fill={theme.text}
      />
      <path
        d="M159.89,177.33a.27.27,0,0,1-.3-.25.28.28,0,0,1,.22-.33.3.3,0,0,1,.08.58Z"
        fill={theme.text}
      />
      <path
        d="M161.68,177.74a.31.31,0,0,1-.22-.36c0-.19.16-.32.3-.3a.31.31,0,0,1,.22.36A.32.32,0,0,1,161.68,177.74Z"
        fill={theme.text}
      />
      <ellipse
        cx={159.56}
        cy={178.72}
        rx={0.26}
        ry={0.25}
        fill={theme.text}
      />
      <path
        d="M172,178a.29.29,0,1,1,.22-.33A.29.29,0,0,1,172,178Z"
        fill={theme.text}
      />
      <path
        d="M173.33,178.06c-.14,0-.19-.25-.12-.45s.23-.33.37-.29.19.25.12.46S173.47,178.11,173.33,178.06Z"
        fill={theme.text}
      />
      <path
        d="M172.67,179.87a.27.27,0,0,1-.21-.33.27.27,0,0,1,.3-.24.26.26,0,0,1,.21.32A.28.28,0,0,1,172.67,179.87Z"
        fill={theme.text}
      />
      <path
        d="M212.78,454.27,190.22,290.81h0l-.63-10.55-56.45-2.68-2.36,8.89C122.86,314.39,82.84,449.4,82.84,449.4l19.55,6.17,58.2-154.7L187.68,454Z"
        fill={theme.text}
      />
      <path
        d="M186.71,278.68c-.15,0-.29-.31-.33-.72s0-.76.18-.77.29.31.33.72S186.85,278.67,186.71,278.68Z"
        fill={theme.text}
      />
      <path
        d="M187.3,284.63c-.14,0-.33-.64-.41-1.46s0-1.5.11-1.51.33.64.41,1.46S187.44,284.62,187.3,284.63Z"
        fill={theme.text}
      />
      <path
        d="M187.92,290.58c-.15,0-.33-.64-.42-1.46s0-1.5.1-1.52.33.64.42,1.46S188.06,290.56,187.92,290.58Z"
        fill={theme.text}
      />
      <path
        d="M188.56,296.52c-.15,0-.33-.64-.42-1.46s0-1.5.09-1.51.34.64.42,1.46S188.7,296.5,188.56,296.52Z"
        fill={theme.text}
      />
      <path
        d="M189.22,302.46c-.14,0-.33-.64-.42-1.46s-.06-1.49.09-1.51.33.64.42,1.46S189.36,302.44,189.22,302.46Z"
        fill={theme.text}
      />
      <path
        d="M189.91,308.4c-.15,0-.34-.64-.44-1.46s-.05-1.49.09-1.51.34.63.43,1.45S190.05,308.38,189.91,308.4Z"
        fill={theme.text}
      />
      <path
        d="M190.61,314.34c-.14,0-.34-.64-.44-1.46s-.06-1.5.08-1.51.34.63.44,1.45S190.75,314.32,190.61,314.34Z"
        fill={theme.text}
      />
      <path
        d="M191.33,320.27c-.14,0-.34-.63-.44-1.45s-.07-1.5.08-1.52.34.63.44,1.45S191.47,320.25,191.33,320.27Z"
        fill={theme.text}
      />
      <path
        d="M192.07,326.2c-.15,0-.35-.63-.45-1.45s-.07-1.5.08-1.51.34.63.44,1.45S192.21,326.18,192.07,326.2Z"
        fill={theme.text}
      />
      <path
        d="M192.82,332.13c-.15,0-.35-.63-.45-1.45s-.07-1.49.07-1.51.34.63.45,1.45S193,332.11,192.82,332.13Z"
        fill={theme.text}
      />
      <path
        d="M193.58,338.06c-.14,0-.34-.63-.45-1.45s-.08-1.49.07-1.51.34.63.45,1.45S193.72,338,193.58,338.06Z"
        fill={theme.text}
      />
      <path
        d="M194.35,344c-.14,0-.34-.63-.45-1.45s-.08-1.5.07-1.51.34.62.45,1.44S194.5,344,194.35,344Z"
        fill={theme.text}
      />
      <path
        d="M195.14,349.92c-.15,0-.35-.63-.46-1.45s-.08-1.5.06-1.52.35.63.46,1.45S195.28,349.9,195.14,349.92Z"
        fill={theme.text}
      />
      <path
        d="M195.93,355.84c-.15,0-.35-.63-.46-1.45s-.08-1.49.06-1.51.35.63.46,1.45S196.07,355.82,195.93,355.84Z"
        fill={theme.text}
      />
      <path
        d="M196.72,361.77c-.14,0-.34-.63-.46-1.45s-.08-1.5.06-1.52.35.63.46,1.45S196.86,361.75,196.72,361.77Z"
        fill={theme.text}
      />
      <path
        d="M197.52,367.69c-.14,0-.35-.63-.46-1.45s-.08-1.49.06-1.51.35.63.46,1.44S197.67,367.67,197.52,367.69Z"
        fill={theme.text}
      />
      <path
        d="M198.33,373.61c-.15,0-.35-.62-.46-1.44s-.09-1.5,0-1.52.35.63.46,1.45S198.47,373.6,198.33,373.61Z"
        fill={theme.text}
      />
      <path
        d="M199.15,379.53c-.14,0-.35-.63-.47-1.44s-.1-1.5,0-1.52.35.63.46,1.44S199.29,379.51,199.15,379.53Z"
        fill={theme.text}
      />
      <path
        d="M200,385.44c-.14,0-.35-.63-.47-1.44s-.11-1.49,0-1.52.36.63.48,1.44S200.16,385.42,200,385.44Z"
        fill={theme.text}
      />
      <path
        d="M200.91,391.34c-.14,0-.36-.62-.48-1.44s-.11-1.49,0-1.51.35.62.48,1.44S201.05,391.32,200.91,391.34Z"
        fill={theme.text}
      />
      <path
        d="M201.8,397.25c-.14,0-.35-.62-.48-1.44s-.11-1.49,0-1.51.35.62.48,1.44S202,397.23,201.8,397.25Z"
        fill={theme.text}
      />
      <path
        d="M202.7,403.15c-.14,0-.36-.62-.48-1.43s-.11-1.5,0-1.52.36.62.48,1.44S202.84,403.13,202.7,403.15Z"
        fill={theme.text}
      />
      <path
        d="M203.6,409.06c-.15,0-.36-.63-.49-1.44s-.1-1.49,0-1.52.36.63.48,1.44S203.74,409,203.6,409.06Z"
        fill={theme.text}
      />
      <path
        d="M204.5,415c-.15,0-.36-.62-.49-1.44s-.11-1.49,0-1.51.35.62.48,1.44S204.64,414.94,204.5,415Z"
        fill={theme.text}
      />
      <path
        d="M205.39,420.88c-.14,0-.35-.63-.48-1.44s-.11-1.5,0-1.52.36.62.49,1.44S205.54,420.85,205.39,420.88Z"
        fill={theme.text}
      />
      <path
        d="M206.29,426.79c-.14,0-.35-.63-.48-1.44s-.11-1.5,0-1.52.36.62.49,1.44S206.44,426.76,206.29,426.79Z"
        fill={theme.text}
      />
      <path
        d="M207.19,432.7c-.14,0-.36-.63-.48-1.44s-.11-1.5,0-1.52.36.62.48,1.44S207.33,432.68,207.19,432.7Z"
        fill={theme.text}
      />
      <path
        d="M208.09,438.61c-.15,0-.36-.62-.49-1.44s-.1-1.5,0-1.52.36.63.48,1.44S208.23,438.59,208.09,438.61Z"
        fill={theme.text}
      />
      <path
        d="M209,444.52c-.15,0-.36-.62-.48-1.44s-.11-1.49,0-1.51.36.62.48,1.44S209.12,444.5,209,444.52Z"
        fill={theme.text}
      />
      <path
        d="M209.86,450.44c-.14,0-.36-.62-.48-1.44s-.1-1.5,0-1.52.35.62.48,1.44S210,450.42,209.86,450.44Z"
        fill={theme.text}
      />
      <path
        d="M210.5,454.92c-.14,0-.3-.3-.36-.71s0-.76.15-.78.31.3.37.71S210.64,454.9,210.5,454.92Z"
        fill={theme.text}
      />
      <path
        d="M101,451.3c.14,0,.15.4,0,.79s-.33.68-.47.64-.15-.4,0-.79S100.87,451.26,101,451.3Z"
        fill={theme.text}
      />
      <path
        d="M102.86,445.51c.13.05,0,.73-.22,1.53s-.57,1.41-.71,1.37,0-.73.22-1.53S102.72,445.47,102.86,445.51Z"
        fill={theme.text}
      />
      <path
        d="M104.73,439.74c.14,0,0,.72-.22,1.52s-.58,1.41-.72,1.36,0-.72.23-1.52S104.6,439.69,104.73,439.74Z"
        fill={theme.text}
      />
      <path
        d="M106.64,434c.14,0,0,.72-.23,1.52s-.59,1.4-.72,1.36,0-.73.23-1.52S106.51,433.92,106.64,434Z"
        fill={theme.text}
      />
      <path
        d="M108.58,428.21c.14,0,0,.72-.24,1.52s-.6,1.4-.73,1.35,0-.72.24-1.52S108.44,428.16,108.58,428.21Z"
        fill={theme.text}
      />
      <path
        d="M110.54,422.45c.14.05,0,.73-.24,1.53s-.61,1.4-.74,1.35,0-.73.24-1.52S110.41,422.41,110.54,422.45Z"
        fill={theme.text}
      />
      <path
        d="M112.53,416.71c.14.05,0,.73-.25,1.52s-.61,1.4-.75,1.35,0-.73.26-1.52S112.4,416.66,112.53,416.71Z"
        fill={theme.text}
      />
      <path
        d="M114.55,411c.13,0,0,.73-.26,1.52s-.62,1.4-.75,1.35,0-.73.26-1.52S114.41,410.93,114.55,411Z"
        fill={theme.text}
      />
      <path
        d="M116.58,405.24c.14.05,0,.73-.26,1.52s-.62,1.4-.76,1.35,0-.73.27-1.52S116.45,405.2,116.58,405.24Z"
        fill={theme.text}
      />
      <path
        d="M118.64,399.52c.14.05,0,.73-.27,1.52s-.62,1.39-.76,1.34,0-.73.27-1.52S118.51,399.47,118.64,399.52Z"
        fill={theme.text}
      />
      <path
        d="M120.72,393.81c.14.05,0,.72-.28,1.51s-.63,1.39-.76,1.34,0-.73.27-1.51S120.59,393.76,120.72,393.81Z"
        fill={theme.text}
      />
      <path
        d="M122.82,388.1c.13,0,0,.73-.28,1.51s-.64,1.39-.77,1.34,0-.73.28-1.52S122.68,388.05,122.82,388.1Z"
        fill={theme.text}
      />
      <path
        d="M124.93,382.39c.14.05,0,.73-.28,1.52s-.64,1.38-.78,1.33,0-.72.29-1.51S124.8,382.34,124.93,382.39Z"
        fill={theme.text}
      />
      <path
        d="M127.06,376.7c.14.05,0,.72-.29,1.51s-.64,1.38-.77,1.33,0-.73.29-1.51S126.93,376.65,127.06,376.7Z"
        fill={theme.text}
      />
      <path
        d="M129.21,371c.13.05,0,.73-.29,1.52s-.65,1.38-.79,1.33,0-.73.3-1.52S129.07,371,129.21,371Z"
        fill={theme.text}
      />
      <path
        d="M131.37,365.32c.13.05,0,.72-.3,1.51s-.65,1.38-.78,1.33,0-.73.29-1.52S131.23,365.26,131.37,365.32Z"
        fill={theme.text}
      />
      <path
        d="M133.54,359.63c.13.05,0,.73-.3,1.52s-.65,1.37-.79,1.32,0-.73.3-1.51S133.4,359.58,133.54,359.63Z"
        fill={theme.text}
      />
      <path
        d="M135.72,354c.13.05,0,.73-.3,1.52s-.66,1.37-.79,1.32,0-.73.3-1.51S135.59,353.9,135.72,354Z"
        fill={theme.text}
      />
      <path
        d="M137.91,348.28c.13.05,0,.73-.3,1.51s-.66,1.38-.8,1.32,0-.72.31-1.51S137.78,348.23,137.91,348.28Z"
        fill={theme.text}
      />
      <path
        d="M140.11,342.6c.13.06,0,.73-.31,1.52s-.66,1.37-.79,1.32,0-.73.31-1.51S140,342.55,140.11,342.6Z"
        fill={theme.text}
      />
      <path
        d="M142.31,336.94c.14.05,0,.72-.31,1.51s-.66,1.37-.79,1.32,0-.73.31-1.51S142.18,336.88,142.31,336.94Z"
        fill={theme.text}
      />
      <path
        d="M144.52,331.27c.14.05,0,.73-.31,1.51s-.66,1.37-.79,1.32,0-.73.31-1.51S144.39,331.22,144.52,331.27Z"
        fill={theme.text}
      />
      <path
        d="M146.74,325.6c.13.06,0,.73-.31,1.52s-.67,1.37-.8,1.32,0-.73.31-1.51S146.6,325.55,146.74,325.6Z"
        fill={theme.text}
      />
      <path
        d="M149,319.94c.14.06,0,.73-.31,1.51s-.66,1.38-.8,1.32,0-.73.32-1.51S148.82,319.89,149,319.94Z"
        fill={theme.text}
      />
      <path
        d="M151.27,314.32c.13.06,0,.73-.35,1.5s-.7,1.36-.83,1.3,0-.72.35-1.5S151.14,314.27,151.27,314.32Z"
        fill={theme.text}
      />
      <path
        d="M153.88,308.83c.13.07-.07.73-.44,1.48s-.78,1.3-.91,1.24.06-.72.44-1.47S153.75,308.76,153.88,308.83Z"
        fill={theme.text}
      />
      <path
        d="M157.11,303.69c.11.09-.18.71-.65,1.4s-1,1.17-1.08,1.1.17-.7.65-1.4S157,303.6,157.11,303.69Z"
        fill={theme.text}
      />
      <path
        d="M160.59,300.87c0,.14-.23.34-.57.52s-.67.28-.76.17.13-.42.52-.63S160.55,300.73,160.59,300.87Z"
        fill={theme.text}
      />
      <path
        d="M151.45,215.2l-35.77-1H79.21a8.84,8.84,0,0,0-8.66,9V248a104.69,104.69,0,0,0,11.9,49.23c6.74,12.65,17.17,25.67,33.23,33.94,14.77-5.54,25.79-20.33,32.53-33a104.69,104.69,0,0,0,11.9-49.23V224.19A8.83,8.83,0,0,0,151.45,215.2Z"
        fill={theme.imageHighlight}
      />
      <polygon
        points="114.45 273.09 101.21 262.14 105.67 256.74 113.65 263.34 126.7 248.37 131.98 252.96 114.45 273.09"
        style={{
          fill: "#fff",
        }}
      />
      <g
        style={{
          opacity: 0.30000000000000004,
        }}
      >
        <path d="M151.45,215.2l-35.77-1H79.21a8.84,8.84,0,0,0-8.66,9V248a104.69,104.69,0,0,0,11.9,49.23c6.74,12.65,17.17,25.67,33.23,33.94,14.77-5.54,25.79-20.33,32.53-33a104.69,104.69,0,0,0,11.9-49.23V224.19A8.83,8.83,0,0,0,151.45,215.2Zm-1.18,35.56a82.76,82.76,0,0,1-9.42,38.94c-5.33,10-13.17,20.31-25.88,26.86-12.7-6.55-20.25-16.85-25.58-26.86A82.87,82.87,0,0,1,80,250.76V231.19a7,7,0,0,1,6.84-7.12h56.6a7,7,0,0,1,6.85,7.12Z" />
      </g>
    </g>
  </svg>
    );
  }
}